reportFilterMixin = require '../../mixins/report-filter'

module.exports = App.SelectReportFilterComponent = Ember.Component.extend reportFilterMixin,
  store: Ember.inject.service()
  session: Ember.inject.service()

  selectedItem: null
  fetchedItems: null

  labelKey: 'name'
  idKey: 'id'

  selectedItemObserver: Ember.observer(
    'selectedItem'
    ->
      selectedItem = @get('selectedItem')

      return if Ember.isEmpty(selectedItem)

      @set('filter.value', Ember.get(selectedItem, @get('idKey')))
  )

  setLocalItem: (->
    value = @get('filter.value')

    return if Ember.isEmpty(value)

    content = @get('content')

    Ember.RSVP.resolve(content).then =>
      selectedItem = content.findBy(@get('idKey'), value)

      @set('selectedItem', selectedItem)
  ).on('init')

  content: Ember.computed(
    'filter.control_options.select_assosiation', 'fetchedItems'
    ->
      return @get('fetchedItems') if @get('fetchedItems')

      options = @get('filter.control_options')

      @set('labelKey', options['labelKey']) if options['labelKey']
      result = null

      if not Ember.isEmpty(options.select_assosiation) and typeof options.select_assosiation is 'string'
        if options.select_assosiation.indexOf('.') == -1
          model = options.select_assosiation.singularize()
          key = if @get('session.isLC') then 'logistics_center_id' else 'organization_id'
          result = @get('store').find model, "#{key}": @get('session').get('currentOrganization.id')
        else
          [object, method] = options.select_assosiation.split('.')
          if object == 'organization'
            @get("session.currentOrganization.#{method}").then (v) =>
              @set('fetchedItems', v)
      else if options.select_options
        result = options.select_options

      result
  )
